<template>
  <div ref="loginForm" class="login-form">
    <div class="logo" v-html="logo"></div>
    <form class="form" @submit.prevent="onFormSubmit">

      <div v-if="responseCheckDuration">
        <div class="message error" style="font-weight: bold; font-size: 17px;">
          Echec - Délai d'attente dépassé
        </div>
        <div class="message info" style="font-size: 16px">
          Veuillez recommencer la procédure de réinitialisation du mot de passe.
        </div>

      </div>
      <div v-else>
        <div class="messages">
          <div v-if="!!infoMessage" class="message info show">
            <i class="fa fa-times" @click="() => infoMessage = null"></i>
            <i class="fa fa-exclamation-circle indicator"></i>
            <div class="message-inner">
              <span>{{ infoMessage }}</span>
            </div>
          </div>
          <div v-if="errorMessages.length > 0" class="message error show">
            <i class="fa fa-times" @click="() => errorMessages = []"></i>
            <i class="fa fa-exclamation-circle indicator"></i>
            <div v-for="(message, idx) in errorMessages" :key="idx" class="message-inner">
              <span>{{ message }}</span>
            </div>
          </div>
        </div>
        <PassordFields @passwordValidity="onPasswordValidity" />
        <Btn :class="['mt-3 default block submit-button', !isPasswordValid ? 'disabled' : '']" @click.native.prevent="onFormSubmit">
          {{ $t('login.loginBtn') }}
        </Btn>
      </div>
    </form>

  </div>
</template>

<script>
import axios from 'axios'
import API from '@/services/API.js'
import Utils from '@/services/utils.js'
import Btn from '@/components/ui/Button'

import src from '@/assets/img/logo2.svg';
import srcSFR from '@/assets/img/logo2-sfr.svg';
import PassordFields from "@/components/settings/PasswordFields.vue";

export default {
  name: 'resetPassword',
  computed:{
    logo(){
      if(this.theme == 'sfr') {
        return srcSFR
      }
      return src
    },
    theme(){
      return Utils.getThemeName()
    }
  },
  components: {
    Btn,
    PassordFields
  },
  data: () => ({
    token: '',
    infoMessage: null,
    errorMessages: [],
    responseCheckDuration:'',
    login: '',
    email: '',
    password: '',
    passwordConfirm: '',
    isPasswordValid: false,
  }),

  methods: {
    onPasswordValidity: function(password) {
      this.isPasswordValid = password.isValid;
      if (password.isValid) {
        this.password = password.pwd;
        this.passwordConfirm = password.pwdConfirm;
      } else {
        this.password = '';
        this.passwordConfirm = '';
      }
    },
    onFormSubmit: function(){
        window.Vfc.$refs.loading.show();
        axios.defaults.headers.app = 'beepiz-front';

        axios.defaults.baseURL = API.apiBaseURL;

        this.infoMessage = null;
        this.errorMessages = [];

        axios.post(API.endpoints.oauth.resetPassword,{
          login: this.$route.query['u'],
          email: this.$route.query['e'],
          password: this.password,
          password_confirmation: this.passwordConfirm,
          token: this.token
        }).then(response => {
          this.infoMessage = response.data.message;
          window.Vfc.$refs.loading.hide();
          setTimeout(() => {
            this.$router.replace({name: 'Login'})
          },2000)
        }).catch(error => {
          window.Vfc.$refs.loading.hide();
          if(error.response.data?.message?.password ){
            (error.response.data.message.password || []).forEach(errorMsg => {
              this.errorMessages.push(Utils.te(`login.errors.${errorMsg}`) ? Utils.t(`login.errors.${errorMsg}`) : Utils.t(`login.errors.default`))
            });
          } else {
            this.errorMessages = [Utils.t(`login.errors.default`)]
          }
        })
    }
  },

  created(){
    this.login= this.$route.query['u']
    this.email= this.$route.query['e']

    this.token = this.$route.query.token
    if (this.token === '') {
      this.$router.replace({name: 'Login'})
    }

    const baseUrl = Utils.getDevantBaseUrl();
    window.location.href = `${baseUrl}/reset-password/${this.token}`
  },


  mounted(){
    this.token = this.$route.query.token
    if (this.token === '') {
      this.$router.replace({name: 'Login'})
    }

    axios.defaults.baseURL = API.apiBaseURL;
    axios.post(API.endpoints.oauth.checkResetDuration, {
      login: this.$route.query['u'],
      email: this.$route.query['e'],
    }).then(response => {
      this.responseCheckDuration = response.data.message.checkDuration
    }).catch(error => {
      if (error.data?.message) {
        this.errorMessages = [error.data.message];
      }
      window.Vfc.$refs.loading.hide();
    })
  },
}
</script>

<style lang="scss" scoped>
  .submit-button.disabled {
    opacity: 0.6;
  }
</style>

